import PIQ from '../../components/piq';

export default [
	{
		path: '/piq/:adf',
		component: PIQ,
	},
];
